import { Stack } from '@mantine/core';
import classNames from 'classnames/bind';
import { PageTitle } from 'components/PageTitle';
import { Panel } from 'components/Panel';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useEffect } from 'react';
import type { RouteChildrenProps } from 'react-router';
import { accountActions } from 'store/account/account.actions';
import type { onSubmitFunction } from 'types/react-hook-form';

import { INTEGRATIONS_ROUTE, Integration } from '../../Integrations.constants';
import { INTEGRATION_UPDATE_CALLBACK } from '../Integration.constants';
import styleIdentifiers from '../Integration.module.scss';
import { useGetIntegrationRights } from '../Integration.utils';
import { IntegrationHeader } from '../IntegrationHeader';
import { DigitealForm } from './DigitealForm';

const styles = classNames.bind(styleIdentifiers);

export const Digiteal = ({ history: { replace } }: RouteChildrenProps) => {
  const { t } = useTranslation();

  const company = useCompanyConfiguration();
  const getIntegrationRights = useGetIntegrationRights();

  const { canActivate, isActive } = getIntegrationRights(Integration.DIGITEAL);
  useEffect(() => {
    if (!canActivate && !isActive) {
      replace(INTEGRATIONS_ROUTE);
    }
  }, [canActivate, isActive, replace]);

  if (!company?.tp_accounting) {
    return (
      <div className={styles('loading')}>
        <div>{t(i18nKeys.LOADING)}</div>
      </div>
    );
  }

  const handleSubmit: onSubmitFunction = () => {
    accountActions.setDigitealConfiguration({
      data: {
        activate: true,
        use_digiteal_integration: true,
      },
      callback: INTEGRATION_UPDATE_CALLBACK,
    });
  };

  return (
    <>
      <PageTitle>
        <PageTitle.Back />
        {Integration.DIGITEAL}
        <PageTitle.Actions>
          <IntegrationHeader name={Integration.DIGITEAL} />
        </PageTitle.Actions>
      </PageTitle>
      <Stack>
        <Panel>
          <DigitealForm onSubmit={handleSubmit} />
        </Panel>
      </Stack>
    </>
  );
};
